/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var merge = require('lodash/merge');

var language = require('./language');
var runtime = require('./runtime');
var overridesPerPlatform = require('./defaults');
var storage = require('./storage');
var mode = require('./mode');
var Logger = require('../../utils/logger');

var _require = require('../../../package.json'),
    version = _require.version;

var eventsEndpointMatcher = /\/(testImpressions|metrics)/;

var base = {
  // Define which kind of object you want to retrieve from SplitFactory
  mode: 'standalone',

  core: {
    // API token (tight to an environment)
    authorizationKey: undefined,
    // key used in your system (only required for browser version)
    key: undefined,
    // toggle impressions tracking of labels
    labelsEnabled: true
  },

  scheduler: {
    // fetch feature updates each 30 sec
    featuresRefreshRate: 30,
    // fetch segments updates each 60 sec
    segmentsRefreshRate: 60,
    // publish metrics each 60 sec
    metricsRefreshRate: 60,
    // publish evaluations each 60 sec
    impressionsRefreshRate: 60,
    // fetch offline changes each 15 sec
    offlineRefreshRate: 15
  },

  urls: {
    // CDN having all the information for your environment
    sdk: 'https://sdk.split.io/api',
    // Storage for your SDK events
    events: 'https://events.split.io/api'
  },

  // Defines which kind of storage we should instanciate.
  storage: {
    type: 'MEMORY'
  },

  // Defines if the logs are enabled, SDK wide.
  debug: false,

  // Instance version.
  version: language + '-' + version
};

function fromSecondsToMillis(n) {
  return Math.round(n * 1000);
}

function setupLogger(enable) {
  if (enable) {
    Logger.API.enable();
  }
}

function defaults(custom) {
  var withDefaults = merge({}, base, overridesPerPlatform, custom);

  // Scheduler periods
  withDefaults.scheduler.featuresRefreshRate = fromSecondsToMillis(withDefaults.scheduler.featuresRefreshRate);
  withDefaults.scheduler.segmentsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.segmentsRefreshRate);
  withDefaults.scheduler.metricsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.metricsRefreshRate);
  withDefaults.scheduler.impressionsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.impressionsRefreshRate);
  withDefaults.scheduler.offlineRefreshRate = fromSecondsToMillis(withDefaults.scheduler.offlineRefreshRate);

  // Startup periods
  withDefaults.startup.requestTimeoutBeforeReady = fromSecondsToMillis(withDefaults.startup.requestTimeoutBeforeReady);
  withDefaults.startup.readyTimeout = fromSecondsToMillis(withDefaults.startup.readyTimeout);

  // ensure a valid SDK mode
  withDefaults.mode = mode(withDefaults.core.authorizationKey, withDefaults.mode);

  // ensure a valid Storage based on mode defined.
  withDefaults.storage = storage(withDefaults);

  setupLogger(withDefaults.debug);

  return withDefaults;
}

var proto = {
  // Switch URLs servers based on target.
  url: function url(target) {
    if (eventsEndpointMatcher.test(target)) {
      return '' + this.urls.events + target;
    }

    return '' + this.urls.sdk + target;
  },


  // Override key on a given configuration object (browser only)
  overrideKey: function overrideKey(key) {
    return (0, _assign2.default)((0, _create2.default)(proto), (0, _extends3.default)({}, this, {
      core: (0, _extends3.default)({}, this.core, {
        key: key
      })
    }));
  },


  // Current ip/hostname information (if available)
  runtime: runtime
};

var SettingsFactory = function SettingsFactory(settings) {
  return (0, _assign2.default)((0, _create2.default)(proto), defaults(settings));
};

module.exports = SettingsFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/settings/index.js
// module id = 510
// module chunks = 11